"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketPolicyOutput = {
    type: "structure",
    required: [],
    members: {
        Policy: {
            shape: {
                type: "string"
            }
        }
    },
    payload: "Policy"
};
//# sourceMappingURL=GetBucketPolicyOutput.js.map